import React, { useState } from 'react'
import EssLeaveRequestForm from './EssLeaveRequestForm'
import essLeaveRequestServices from '../essLeaveRequestServices'
import moment from 'moment'
import { useAppData } from '../../../../context/AppDataContext'

function ESSLeaveRequest() {
    const { getMasterLabel, employeeDD, getDDDataById } = useAppData();
    const [leaveRequestList, setLeaveRequestList] = useState(null);

    const getLeaveRequestList = () => {
        essLeaveRequestServices.getList().then(res => {
            setLeaveRequestList(res.data);
        }).catch(error => console.log(error));
    }

    const getStatusBadge = (status) => {
        const config = {
            1: { class: 'bg-warning text-dark', label: 'Requested' },
            2: { class: 'bg-success text-white', label: 'Approved' },
            3: { class: 'bg-danger text-white', label: 'Rejected' }
        };
        const current = config[status] || { class: 'bg-secondary', label: 'Unknown' };
        return <span className={`badge rounded-pill fw-normal ${current.class}`}>{current.label}</span>;
    }

    return (
        <div className="py-4">
            {/* SECTION 1: CREATE REQUEST (FORM) */}
            <div className="row mb-5">
                <div className="col-12">
                    <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white py-3">
                            <h5 className="mb-0 fw-bold text-primary">New Leave Request</h5>
                        </div>
                        <div className="card-body p-4">
                            <EssLeaveRequestForm callBack={getLeaveRequestList} />
                        </div>
                    </div>
                </div>
            </div>

            <hr className="my-4 opacity-25" />

            {/* SECTION 2: LEAVE HISTORY (LIST) */}
            <div className="row">
                <div className="col-12">
                    <div className="text-center mb-3 px-1">
                        
                        {!leaveRequestList && (
                            <button className='btn btn-outline-primary' onClick={getLeaveRequestList}>
                               View Leave Request
                            </button>
                        )}
                    </div>

                    {leaveRequestList && (
                        <div className="bg-white rounded shadow-sm overflow-hidden">
                            {/* Header: Visible only on Desktop */}
                            <div className="d-none d-md-flex row mx-0 py-3 bg-light border-bottom text-muted small fw-bold">
                                <div className="col-md-3 ps-4">DATE DURATION</div>
                                <div className="col-md-2 text-center">DAYS</div>
                                <div className="col-md-2">LEAVE TYPE</div>
                                <div className="col-md-3">MESSAGE</div>
                                <div className="col-md-2 text-end pe-4">STATUS</div>
                            </div>

                            {/* List Items */}
                            {leaveRequestList.map((leave, index) => (
                                <div key={leave.id} 
                                    className={`row mx-0 py-3 align-items-center border-bottom hover-bg-light ${index % 2 === 0 ? 'bg-white' : 'bg-light-subtle'}`}>
                                    
                                    {/* Date Range */}
                                    <div className="col-12 col-md-3 ps-md-4 mb-2 mb-md-0">
                                        <div className="d-md-none text-muted small uppercase mb-1">Duration</div>
                                        <div className="fw-bold text-dark">
                                            {moment(leave.startDate).format("MMM D")} - {moment(leave.endDate).format("MMM D, YYYY")}
                                        </div>
                                    </div>

                                    {/* Day Count */}
                                    <div className="col-6 col-md-2 text-md-center mb-2 mb-md-0">
                                        <div className="d-md-none text-muted small">Days</div>
                                        <span className="text-secondary">
                                            {moment(leave.endDate).diff(moment(leave.startDate), "days") + 1} d
                                        </span>
                                    </div>

                                    {/* Type */}
                                    <div className="col-6 col-md-2 mb-2 mb-md-0 text-md-start">
                                        <div className="d-md-none text-muted small">Type</div>
                                        <span className="text-dark">{getMasterLabel("leave-type", leave.leaveType)}</span>
                                    </div>

                                    {/* Message */}
                                    <div className="col-12 col-md-3 mb-3 mb-md-0">
                                        <div className="d-md-none text-muted small">Message</div>
                                        <div className="small text-muted text-truncate" title={leave.message}>
                                            {leave.message || <span className="fst-italic opacity-50">No description provided</span>}
                                        </div>
                                    </div>

                                    {/* Status & Approver */}
                                    <div className="col-12 col-md-2 text-md-end pe-md-4">
                                        <div className="d-flex flex-column align-items-md-end">
                                            {getStatusBadge(leave.status)}
                                            {leave.updatedBy && (
                                                <div className="mt-2 text-muted" style={{ fontSize: '0.7rem' }}>
                                                    <span className="fw-bold">Modified by:</span><br/>
                                                    {getDDDataById(employeeDD, leave.updatedBy).label}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ESSLeaveRequest